import { readServerUrlFromBuildEnv } from '../lib/env';

/** Canonical production origin (Vercel). */
export const PRODUCTION_APP_ORIGIN = 'https://www.takshify.ai';

/**
 * App origin for auth redirects and absolute URLs.
 * In the browser, always uses the current host (local or production).
 */
export function getAppOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  const fromEnv = readServerUrlFromBuildEnv()?.replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  return PRODUCTION_APP_ORIGIN;
}

/**
 * Same-origin API path. Relative in the browser (CRA proxy locally, Vercel in prod).
 * @param {string} path
 */
export function apiUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (typeof window !== 'undefined') return normalized;
  return `${getAppOrigin()}${normalized}`;
}
